import React, { useState } from "react";
import "./index.scss";

interface TabProps {
  tabTitle: string;
  children: any;
  isActive?: Boolean;
  displayCondition?: boolean;
  callback?: Function | undefined;
}

export const Tab = (props: TabProps) => {
  const { isActive } = props;
  return (
    <div className={"tab-component__tab-content " + (isActive ? "active" : "")}>
      {props.children}
    </div>
  );
};

interface TabsProps {
  children: React.ReactElement<TabProps>[];
  className?: string;
  title?: string;
  activeTab?: number;
}

const Tabs = (props: TabsProps) => {
  const [activeTab, setActiveTab] = useState(props.activeTab || 0);

  return (
    <div className={"tab-component " + props.className}>
      {props.title ? (
        <div className="tab-component__title">{props.title}</div>
      ) : null}
      <ul className="tab-component__tab-headers">
        {props.children
          .filter(tab => {
            const { displayCondition } = tab.props;
            return displayCondition === undefined || displayCondition === true;
          })
          .map((tab: React.ReactElement<TabProps>, index: number) => {
            let tabProps: TabProps = tab.props || {};
            return (
              <li
                key={index}
                className={`tab-component__tab-header ${
                  activeTab === index ? "active" : ""
                }`}
              >
                <a
                  onMouseDown={() => setActiveTab(index)}
                  onMouseUp={() => {
                    if (tabProps.callback !== undefined) {
                      tabProps.callback();
                    }
                  }}
                  className="tab-component__tab-header-link"
                >
                  {tabProps.tabTitle}
                </a>
              </li>
            );
          })}
      </ul>
      <div>
        {props.children
          .filter(tab => {
            const { displayCondition } = tab.props;
            return displayCondition === undefined || displayCondition === true;
          })
          .map((child: React.ReactElement<TabProps>, index: number) => {
            return (
              <div className="tab-component__content" key={index}>
                {React.cloneElement(child, { isActive: activeTab === index })}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Tabs;
